import { filter, map, reduce } from 'mostc';
import { concat, from, recoverWith, switchLatest, throwError, unfold } from 'most';
import { create as create$1 } from '@most/create';
import { F, equals, nthArg, pipe, range } from 'ramda';
import { curry2 } from '@team-griffin/capra';

var concatArray = reduce(function (main$, child$) {
  return main$ == null ? child$ : concat(main$, child$);
}, null);

var fromEagerPromise = function fromEagerPromise(f) {
  return create$1(function (add, end, error) {
    var rawPromise = f();

    return rawPromise.then(function (data) {
      add(data);
      end();
    }, error);
  });
};

var fromFuture = function fromFuture(future) {
  return create$1(function (add, end, err) {
    future.fork(err, function (data) {
      add(data);
      end();
    });
  });
};

var ignoreElements = function ignoreElements(stream$) {
  return pipe(filter(F))(stream$);
};

var valueArg = nthArg(1);

var last = function last(stream$) {
  return fromEagerPromise(function () {
    return reduce(valueArg, void 0, stream$);
  });
};



// It is possible that this has some performance issues.
// If this is the case we can investigate using `skipUntil` with
// the original stream being its own signal

var mapError = curry2(function (f, stream) {
  return recoverWith(function (err) {
    return throwError(f(err));
  }, stream);
});

var range$1 = pipe(range, from);

var switchMap = curry2(function (f, stream$) {
  return pipe(map(f), switchLatest)(stream$);
});

var tapError = curry2(function (f, stream) {
  return recoverWith(function (err) {
    f(err);
    return throwError(err);
  }, stream);
});

var toConsumableArray = function (arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) arr2[i] = arr[i];

    return arr2;
  } else {
    return Array.from(arr);
  }
};

var toArray$1 = function toArray$$1(stream$) {
  return fromEagerPromise(function () {
    return reduce(function (acc, x) {
      return [].concat(toConsumableArray(acc), [x]);
    }, [], stream$);
  });
};

var waitUntil = function waitUntil(f) {
  var interval = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 500;

  return unfold(function (done) {
    return new Promise(function (resolve) {
      setTimeout(function () {
        Promise.resolve(f()).then(function (value) {
          resolve({
            value: value,
            seed: value,
            done: done
          });
        });
      }, interval);
    });
  }, false).filter(equals(true));
};

var index = {
  concatArray: concatArray,
  fromEagerPromise: fromEagerPromise,
  fromFuture: fromFuture,
  ignoreElements: ignoreElements,
  last: last,
  mapError: mapError,
  range: range$1,
  switchMap: switchMap,
  tapError: tapError,
  toArray: toArray$1,
  waitUntil: waitUntil
};

export { concatArray, fromEagerPromise, fromFuture, ignoreElements, last, mapError, range$1 as range, switchMap, tapError, toArray$1 as toArray, waitUntil };
export default index;
